import { Router, NavigationEnd, Event } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import { PermissionsService } from "src/app/helpers/permissions.service";

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.scss"],
})
export class MenuComponent implements OnInit {
  location = null;
  permissions: [];

  private readonly registrationRoutes = [
    "/registrations",
    "/users/create",
    "/companies/create",
    "/drivers/create",
    "/vehicles/create",
    "/maintenance/create",
    "/terminal-alarme/create",
    "/terminal/create",
    "/atividades/create",
    "/modulo/create",
    "/perfil/create",
    "/perfil-tipo/create",
    "/funcionalidade/create",
    "/funcionalidade-tipo/create",
  ];

  private readonly consultationRoutes = [
    "/consultations",
    "/users",
    "/companies",
    "/drivers",
    "/vehicles",
    "/routes",
    "/electric-fence",
    "/maintenance",
    "/terminal-alarme",
    "/terminal",
    "/atividades",
    "/modulo",
    "/perfil",
    "/perfil-tipo",
    "/sensor",
    "/funcionalidade",
    "/funcionalidade-tipo",
  ];

  constructor(
    private router: Router,
    public permissionService: PermissionsService
  ) {
    router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.location = event.url;
      }
    });
  }

  ngOnInit(): void {
    this.permissions = this.permissionService.getPermissions();
  }

  isRouteActive(routes: string[]): boolean {
    return !!this.location && routes.indexOf(this.location) !== -1;
  }

  isHomeActive(): boolean {
    return this.location === null || this.location === "/";
  }

  isPainelEventosActive(): boolean {
    return this.isRouteActive(["/painel-evento"]);
  }

  isGridActive(): boolean {
    return this.isRouteActive(["/grid"]);
  }

  isGraficoEventosActive(): boolean {
    return this.isRouteActive(["/painel-evento-grafico"]);
  }

  isRegistrationsActive(): boolean {
    return this.isRouteActive(this.registrationRoutes);
  }

  isConsultationsActive(): boolean {
    return this.isRouteActive(this.consultationRoutes);
  }

  isReportsActive(): boolean {
    return this.isRouteActive(["/reports", "/reports/acompanhamnto-motorista"]);
  }

  isBiActive(): boolean {
    return this.isRouteActive(["/bi"]);
  }

  isSettingsActive(): boolean {
    return this.location === "/settings";
  }
}
